// eslint-disable-next-line jira/filename-case
import { createHook } from '../index.tsx';
import {
	getPremiumFlowResolvedPromise,
	getPremiumLastVisit,
	getPremiumModalDismissed,
} from './premium.tsx';

export const usePremiumModalDismissed: () =>
	| {
			status: 'loading';
	  }
	| {
			status: 'loaded';
			value: boolean;
	  } = createHook(getPremiumModalDismissed);
export const usePremiumLastVisit: () =>
	| {
			status: 'loading';
	  }
	| {
			status: 'loaded';
			value: boolean;
	  } = createHook(getPremiumLastVisit);

export const usePremiumFlowResolvedPromise: () => Promise<void> = createHook(
	getPremiumFlowResolvedPromise,
);
